/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerContractualizationPricingDto
 */
export interface BorrowerContractualizationPricingDto {
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    discountPrice: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    discountPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    initialPrice: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    newPrice: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    totalPriceEightYears: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    averageRate: number;
    /**
     * 
     * @type {number}
     * @memberof BorrowerContractualizationPricingDto
     */
    monthPrice: number;
}

/**
 * Check if a given object implements the BorrowerContractualizationPricingDto interface.
 */
export function instanceOfBorrowerContractualizationPricingDto(value: object): value is BorrowerContractualizationPricingDto {
    if (!('discountPrice' in value) || value['discountPrice'] === undefined) return false;
    if (!('discountPercentage' in value) || value['discountPercentage'] === undefined) return false;
    if (!('initialPrice' in value) || value['initialPrice'] === undefined) return false;
    if (!('newPrice' in value) || value['newPrice'] === undefined) return false;
    if (!('totalPriceEightYears' in value) || value['totalPriceEightYears'] === undefined) return false;
    if (!('averageRate' in value) || value['averageRate'] === undefined) return false;
    if (!('monthPrice' in value) || value['monthPrice'] === undefined) return false;
    return true;
}

export function BorrowerContractualizationPricingDtoFromJSON(json: any): BorrowerContractualizationPricingDto {
    return BorrowerContractualizationPricingDtoFromJSONTyped(json, false);
}

export function BorrowerContractualizationPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractualizationPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'discountPrice': json['discountPrice'],
        'discountPercentage': json['discountPercentage'],
        'initialPrice': json['initialPrice'],
        'newPrice': json['newPrice'],
        'totalPriceEightYears': json['totalPriceEightYears'],
        'averageRate': json['averageRate'],
        'monthPrice': json['monthPrice'],
    };
}

export function BorrowerContractualizationPricingDtoToJSON(json: any): BorrowerContractualizationPricingDto {
    return BorrowerContractualizationPricingDtoToJSONTyped(json, false);
}

export function BorrowerContractualizationPricingDtoToJSONTyped(value?: BorrowerContractualizationPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'discountPrice': value['discountPrice'],
        'discountPercentage': value['discountPercentage'],
        'initialPrice': value['initialPrice'],
        'newPrice': value['newPrice'],
        'totalPriceEightYears': value['totalPriceEightYears'],
        'averageRate': value['averageRate'],
        'monthPrice': value['monthPrice'],
    };
}

